import React__default from 'react';
import classNames from './../../external_lib/classnames/index.js';
import { Item as $1bf158f521e1b1b4$export$6d08773d2e66f8f2, Trigger as $1bf158f521e1b1b4$export$41fb9f06171c75f4, Content as $1bf158f521e1b1b4$export$7c6e2c02157bb7d2, Root as $1bf158f521e1b1b4$export$be92b6f5f03c0fe9 } from './../../external_lib/@radix-ui/react-accordion/dist/index.module.js';
import styles from '../../components/helpers/accordion/accordion.module.scss.js';
function Accordian(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b,
    header = _a.header,
    content = _a.content,
    value = _a.value,
    disabled = _a.disabled,
    onClick = _a.onClick;
  return React__default.createElement($1bf158f521e1b1b4$export$6d08773d2e66f8f2, {
    disabled: disabled,
    value: value,
    className: classNames(styles.accordionItem, className)
  }, React__default.createElement($1bf158f521e1b1b4$export$41fb9f06171c75f4, {
    onClick: function () {
      return onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    className: styles.accordionTrigger
  }, header), React__default.createElement($1bf158f521e1b1b4$export$7c6e2c02157bb7d2, {
    className: styles.accordionContent
  }, content));
}
var AccordionGroup = $1bf158f521e1b1b4$export$be92b6f5f03c0fe9;
export { AccordionGroup, Accordian as default };
//# sourceMappingURL=index.js.map
